import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 15h10v5h5v-5h5v-5h-10v-5h-5v5h-5l0 5","key":"svg-0"}],["path",{"d":"M7 15v-5h5v5h5v-5","key":"svg-1"}]]

const IconCubeUnfolded = createReactComponent('outline', 'cube-unfolded', 'CubeUnfolded', __iconNode);

export default IconCubeUnfolded;